module.exports = __webpack_public_path__ + "static/lines_only-b4550c2b5e18bbb41107870082bf690a.gif";